import React from "react";
import { Link } from "react-router-dom";
import { BOAT_FACTS, GALLERY } from "../data/cruiseData";
import { Check, ArrowRight, Users, Anchor } from "lucide-react";
import SEOHead from "../components/SEOHead";

export default function Boat() {
 return (
 <main className="pt-32 pb-24" data-testid="boat-page">
 <SEOHead
  title="MV Sydney Magic | The Boat | Magic Cruises Sydney Harbour"
  description="MV Sydney Magic is Sydney Harbour's premier two-deck event boat. 120 guest capacity, open-air upper deck, climate-controlled saloon, fully licensed bar, built-in sound. Charter the boat for weddings, corporates and parties."
  image="https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/srsraacs_sydney%20cruises%20boats.png"
  canonical="/boat"
  keywords="MV Sydney Magic, Sydney Harbour boat hire, two deck event boat Sydney, function boat Sydney, party boat capacity 120"
  includeLocalBusiness
  breadcrumbs={[
   { name: "Home", url: "/" },
   { name: "The Boat", url: "/boat" },
  ]}
 />
 <div className="mx-auto max-w-7xl px-5 lg:px-10">
 <div className="eyebrow">The Vessel</div>
 <h1 className="font-display text-4xl lg:text-7xl mt-3 mb-6 text-ink leading-[1]">MV <span className="text-pink italic">Sydney Magic</span>.</h1>
 <p className="text-ink-soft max-w-2xl text-lg">A two-deck Sydney Harbour cruiser purpose-built for events. Open-top upper deck for ceremonies &amp; golden hour photos. Climate-controlled lower deck with built-in sound for the dance floor.</p>

 <div className="grid lg:grid-cols-2 gap-10 mt-12">
 <div className="plate aspect-[4/5]"><img src={GALLERY[0]} alt="MV Sydney Magic" className="absolute inset-0 w-full h-full object-cover" /></div>
 <div>
 <div className="grid grid-cols-2 gap-3 mb-6">
 <div className="bg-white rounded-xl border border-[hsla(222,20%,80%,0.5)] p-5"><Users className="w-5 h-5 text-pink" /><div className="font-display text-4xl mt-2 text-ink">{BOAT_FACTS.capacityPrivate}</div><div className="text-xs uppercase tracking-wider font-bold text-ink-mute">Max Guests</div></div>
 <div className="bg-white rounded-xl border border-[hsla(222,20%,80%,0.5)] p-5"><Anchor className="w-5 h-5 text-pink" /><div className="font-display text-4xl mt-2 text-ink">{BOAT_FACTS.decks}</div><div className="text-xs uppercase tracking-wider font-bold text-ink-mute">Decks</div></div>
 </div>
 <h2 className="font-display text-3xl mb-4 text-ink">Features</h2>
 <ul className="space-y-2">{BOAT_FACTS.features.map((f, i) => <li key={i} className="flex gap-3 text-ink-soft"><Check className="w-4 h-4 text-pink mt-1 shrink-0" />{f}</li>)}</ul>
 <Link to="/contact" className="btn-magic mt-8 inline-flex">Charter The Magic <ArrowRight className="w-3.5 h-3.5" /></Link>
 </div>
 </div>
 </div>
 </main>
 );
}
